import { Accordion, AccordionItem, AccordionButton, Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';

import Styles from './ItemsAccordion.styles';
import { iconMap } from '../../helpers';
import { FormattedMessageWithLink } from '../FormattedMessageWithLink';

import type {
  ResellerRegistrationProps,
  ResellerRegistrationDetail,
} from 'domains/reseller-registration';

export const ItemsAccordion = ({ items }: ResellerRegistrationProps) => {
  const detail = (items as ResellerRegistrationDetail) || {};
  const isShowAccordion = detail?.statusMessage && detail?.message;
  if (!isShowAccordion) {
    return null;
  }
  return (
    <Accordion type='multiple' startOpen={true}>
      <AccordionItem value='start'>
        <AccordionButton>
          <Flex gap='$2' align='center'>
            {iconMap[detail?.status ?? 'defaultButtonIcon']}
            <ResponsiveFloraTypography
              fontSize='bodyLargeShort'
              color='$backgroundAltSecondary'
              fontWeight='medium'
            >
              {detail?.statusMessage}
            </ResponsiveFloraTypography>
          </Flex>
        </AccordionButton>
        <Styles.AccordionPanel>
          <ResponsiveFloraTypography
            fontSize='bodySmallStandard'
            color='$nonInteractiveAuxiliar'
            fontWeight='medium'
          >
            <FormattedMessageWithLink
              message={detail?.message}
              messageObject={detail?.messageObject}
            />
          </ResponsiveFloraTypography>
        </Styles.AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
